import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { rootReducer } from './rootReducer';

const sentryEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) => ({ type: action.type }),
  stateTransformer: (_state) => null,
});

export const store = configureStore({
  reducer: rootReducer,
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryEnhancer),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
